<template>
  <div
    class="section2 px-3 pt-4 mt-2 bg-white footer-button-box-parent"
    :class="
      showsAttendanceCorrection || isShowsEvaluationButton
        ? 'footer-button-box-parent'
        : ''
    "
  >
    <p class="text-mild text-size-14 text-weight-500">事業所連絡</p>
    <div class="bg-white border border-outline-color round-4 mb-3 px-3 mt-1">
      <RouterLink
        :to="{
          name: 'MessageRoomDetail',
          params: {
            officeId: application.order.office.id
          }
        }"
        class="d-flex justify-content-between align-items-center border-outline-color py-3"
      >
        <p class="d-flex align-items-center text-size-14">
          メッセージ
          <AppBadge v-if="!isSentMessage" class="ml-1">
            要挨拶
          </AppBadge>
        </p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </RouterLink>
      <RouterLink
        v-if="application && application.status === 'applied'"
        :to="cancelRoute"
        class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
      >
        <p class="text-size-14">キャンセル</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </RouterLink>
      <div
        @click="isShowEmergencyContactModal = true"
        class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
        role="button"
      >
        <p class="text-size-14">緊急連絡先</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </div>

      <BModal
        v-model="isShowEmergencyContactModal"
        title="緊急連絡先"
        hide-footer
        centered
      >
        <div class="px-3 pb-3">
          <p>事業所名：{{ application.order.office.name }}</p>
          <p>担当者：{{ application.order.office.staffName }}</p>
          <p>
            電話番号：<a
              :href="'tel:' + application.order.office.phoneNumber"
              class="text-blue"
              >{{ application.order.office.phoneNumber }}</a
            >
          </p>
          <p
            v-if="application.order.office.emergencyContact"
            class="text-pre-wrap mt-2"
          >
            {{ application.order.office.emergencyContact }}
          </p>
          <a :href="'tel:' + application.order.office.phoneNumber">
            <AppButton variant="green" :block="true" class="d-block mt-3"
              >電話をする</AppButton
            >
          </a>
        </div>
      </BModal>
    </div>

    <p class="text-mild text-size-14 text-weight-500">お仕事情報</p>
    <div class="bg-white border border-outline-color round-4 mb-3 px-3 mt-1">
      <RouterLink
        :to="{
          name: 'OrdersDetail',
          params: {
            orderId: application.order.id
          },
          query: {
            transitionSource: 'ApplicationDetail'
          }
        }"
        class="d-flex justify-content-between align-items-center border-outline-color py-3"
      >
        <p class="text-size-14">お仕事詳細</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </RouterLink>
      <RouterLink
        :to="{
          name: 'OrdersDetail',
          params: {
            orderId: application.order.id
          },
          query: {
            transitionSource: 'ApplicationDetail'
          },
          hash: '#applicationCondition'
        }"
        class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
      >
        <p class="text-size-14">申込条件・持ち物</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </RouterLink>
      <a
        class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
        role="button"
        @click="showMap"
      >
        <p class="text-size-14">住所（地図アプリを起動）</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </a>
      <RouterLink
        :to="{
          name: 'NoticeOfEmploymentsList',
          params: {
            applicationId: application.id
          }
        }"
        class="d-flex justify-content-between align-items-center border-top border-outline-color py-3"
      >
        <p class="text-size-14">労働条件通知書</p>
        <FeatherIcon icon="chevron-right" size="1x" class="text-gray-05 ml-2" />
      </RouterLink>
    </div>
    <!-- その他の項目は現状1個しかないので、項目ごとv-ifする -->

    <template v-if="favoriteOffice == null || !favoriteOffice.isFavorite">
      <p class="text-mild text-size-14 text-weight-500">その他</p>
      <div class="bg-white border border-outline-color round-4 mb-3 px-3 mt-1">
        <div
          @click="openConfirmFavoriteOffice"
          role="button"
          class="d-flex justify-content-between align-items-center border-outline-color py-3"
        >
          <p class="text-size-14">お気に入り事業所に登録</p>
          <FeatherIcon
            icon="chevron-right"
            size="1x"
            class="text-gray-05 ml-2"
          />
        </div>
      </div>
    </template>

    <div
      v-if="showsAttendanceCorrection || isShowsEvaluationButton"
      class="d-flex fixed-bottom border-top border-gray-04 footer-button-box"
    >
      <AppButton
        v-if="showsAttendanceCorrection"
        block
        variant="outline-gray-04"
        class="mx-2 my-3 bg-white text-black footer-button"
      >
        <RouterLink
          :to="{
            name: attendanceCorrectionToName,
            params: {
              applicationId: application.id
            }
          }"
          class="text-size-14 d-block footer-button-link"
        >
          勤怠変更
          <AppBadge class="ml-1" :variant="attendanceCorrectionAppBadgeVariant">
            {{ attendanceCorrectionAppBadgeText }}
          </AppBadge>
        </RouterLink>
      </AppButton>
      <AppButton
        v-if="isShowsEvaluationButton"
        block
        class="mx-2 my-3 footer-button"
      >
        <RouterLink
          :to="{
            name: 'ApplicationEvaluation',
            params: {
              applicationId: application.id
            }
          }"
          class="text-size-14 d-block footer-button-link"
        >
          評価
        </RouterLink>
      </AppButton>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import AppBadge from "@/components/atoms/other/AppBadge.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { FavoriteOffice } from "@/types/office/FavoriteOffice";
import { Application } from "@/types/order/Application";
import { openInNewWindow } from "@/utils/browserUtil";
import { addWeeks, now, parseISO } from "@/utils/date";

@Component({
  components: {
    AppBadge,
    AppButton,
    FeatherIcon
  }
})
export default class ApplicationsMenu extends Vue {
  @Prop({
    type: Object,
    default: () => ({})
  })
  application!: Application;

  @Prop({
    type: Object,
    default: () => ({})
  })
  favoriteOffice!: FavoriteOffice | null;

  @Prop({
    type: Boolean,
    default: false
  })
  isSentMessage!: boolean;

  isShowEmergencyContactModal = false;

  showMap() {
    // @ts-ignore
    const office = this.application.order.office;
    openInNewWindow(
      `https://www.google.com/maps/search/?api=1&query=${office.latitude},${office.longitude}`
    );
  }

  get showsAttendanceCorrection(): boolean {
    // 勤務完了済みで、勤怠が予定と一定以上異なっている場合は表示する
    const application = this.application;
    if (
      application &&
      application.status === "done" &&
      application.order &&
      application.attendanceCorrection
    ) {
      return true;
    }

    // TODO: ここの処理が有効になることはない気がする。ダイアログが表示されて強制的に別画面に遷移していないか要確認

    // 出勤処理を忘れたまま、終了日時を過ぎてしまったケース
    // 終了日時〜終了日時の一週間後の間だけ表示する
    const nowValue = now();
    const endDateTime = parseISO(application.appliedStartWorkAt);
    return (
      !["canceled", "requested_cancel"].includes(application?.status) &&
      application?.appliedStartWorkAt === null &&
      nowValue > endDateTime &&
      nowValue < addWeeks(endDateTime, 1)
    );
  }

  get isShowsEvaluationButton() {
    return (
      this.application &&
      this.application.status === "done" &&
      this.application.order &&
      (!this.application.attendanceCorrection ||
        this.application.attendanceCorrection.status === "approved")
    );
  }

  get attendanceCorrectionAppBadgeText() {
    if (this.application.attendanceCorrection?.status === "approved") {
      return "承認済";
    } else if (this.application.attendanceCorrection?.status === "rejected") {
      return "再申請してください";
    } else if (this.application.attendanceCorrection?.status === "submitted") {
      return "申請中";
    } else {
      return "申請してください";
    }
  }

  get attendanceCorrectionAppBadgeVariant() {
    if (this.application.attendanceCorrection?.status === "approved") {
      return "primary";
    } else if (this.application.attendanceCorrection?.status === "rejected") {
      return "red";
    } else if (this.application.attendanceCorrection?.status === "submitted") {
      return "green";
    } else {
      return "red";
    }
  }

  get attendanceCorrectionToName() {
    return this.application.attendanceCorrection === null ||
      this.application.attendanceCorrection?.status === "unsubmitted"
      ? "AttendanceCorrection"
      : "AttendanceCorrectionDetail";
  }

  async openConfirmFavoriteOffice() {
    const isOk = await this.$bvModal.msgBoxConfirm(
      `「${this.application.order.office.name}」をお気に入り事業所に登録しますか？`,
      {
        okTitle: "OK",
        cancelTitle: "キャンセル",
        cancelVariant: "gray-03",
        centered: true
      }
    );
    if (isOk) {
      this.$emit("addFavoriteOffice", this.favoriteOffice?.id);
    }
  }

  get cancelRoute() {
    return {
      name: "OrdersCancelPolicyDisplay",
      params: {
        applicationId: this.application.id
      },
      query: {
        applicationId: this.application.id
      }
    };
  }
}
</script>

<style lang="scss" scoped>
.footer-button-box {
  bottom: 80px;
  // fixed-bottomでz-indexが1030になってしまうので0にする
  z-index: 0;
  background-color: #f9f9f9;
}

.footer-button-box-parent {
  padding-bottom: 80px;
}

.text-size-14 {
  font-size: 14px;
}

.footer-button {
  padding: 0;
}

.footer-button-link {
  padding-top: 11px;
  padding-right: 0.75rem;
  padding-bottom: 11px;
  padding-left: 0.75rem;
}
</style>
